'use client';

import indexationTableFilters from '@/app/dashboard/revenue/indexation/tables/filters';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  IndexationSettingConfig,
  type IndexationSetting,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const IndexationSettingItem: RelationFieldProps<IndexationSetting> = {
  nested: getRelationFieldNames(IndexationSettingConfig),
  filters: indexationTableFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex items-center',
          isRelationField && 'w-full justify-between'
        )}
      >
        {!isRelationField && <Dot />}
        <span>{item.customId ?? 'Inget ID angett'}</span>
      </div>
    ),
  }),
};
